(() => {
  if (window.LmdlHomepageBlocksLoaded) return;
  window.LmdlHomepageBlocksLoaded = true;

  const selector = '[data-lmdl-popup]';

  const canDisplayAtCurrentWidth = (popup) => {
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (isMobile && popup.classList.contains('lmdl-popup--hide-mobile')) return false;
    if (!isMobile && popup.classList.contains('lmdl-popup--hide-desktop')) return false;
    return true;
  };

  const initPopup = (popup) => {
    if (!popup || popup.dataset.lmdlReady === 'true') return;
    popup.dataset.lmdlReady = 'true';

    const panel = popup.querySelector('[role="dialog"]');
    const success = popup.querySelector('.lmdl-form-success');
    const trigger = popup.dataset.trigger || 'delay';
    const delay = Math.max(0, Number(popup.dataset.delay || 3000));
    const scrollPercent = Math.min(90, Math.max(10, Number(popup.dataset.scroll || 40)));
    const days = Math.max(1, Number(popup.dataset.days || 14));
    const designMode = popup.dataset.designMode === 'true';
    const storageKey = `lmdl-popup-${popup.id}`;
    let opener = null;
    let timer = null;
    let triggerCleanup = null;

    const clearTrigger = () => {
      if (triggerCleanup) triggerCleanup();
      triggerCleanup = null;
    };

    const show = () => {
      if (!canDisplayAtCurrentWidth(popup)) return;
      clearTrigger();
      opener = document.activeElement;
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('lmdl-popup-lock');
      window.setTimeout(() => {
        const firstTarget = success || panel;
        if (firstTarget && typeof firstTarget.focus === 'function') firstTarget.focus({ preventScroll: true });
      }, 30);
    };

    const close = ({ remember = true } = {}) => {
      if (timer) window.clearTimeout(timer);
      clearTrigger();
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      if (!document.querySelector(`${selector}.is-open`)) document.documentElement.classList.remove('lmdl-popup-lock');

      if (remember && !designMode) {
        try {
          localStorage.setItem(storageKey, String(Date.now() + days * 86400000));
        } catch (error) {
          /* Le pop-up reste fonctionnel si le stockage est bloqué. */
        }
      }

      if (opener && typeof opener.focus === 'function') opener.focus({ preventScroll: true });
    };

    popup.querySelectorAll('[data-lmdl-close]').forEach((element) => {
      element.addEventListener('click', () => close());
    });

    popup.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
      if (event.key !== 'Tab' || !panel) return;

      const focusable = [...panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')]
        .filter((element) => element.offsetParent !== null);
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    let hidden = false;
    if (!designMode && !success) {
      try {
        hidden = Date.now() < Number(localStorage.getItem(storageKey) || 0);
      } catch (error) {
        hidden = false;
      }
    }

    if (success || designMode) {
      timer = window.setTimeout(show, designMode ? 250 : 0);
    } else if (!hidden) {
      if (trigger === 'scroll') {
        const onScroll = () => {
          const scrollable = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
          if ((window.scrollY / scrollable) * 100 >= scrollPercent) show();
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        triggerCleanup = () => window.removeEventListener('scroll', onScroll);
        onScroll();
      } else if (trigger === 'exit' && window.matchMedia('(min-width: 750px)').matches) {
        const onExit = (event) => {
          if (event.clientY <= 5) show();
        };
        document.addEventListener('mouseout', onExit);
        triggerCleanup = () => document.removeEventListener('mouseout', onExit);
      } else {
        timer = window.setTimeout(show, delay);
      }
    }

    popup._lmdlShow = show;
    popup._lmdlClose = close;
  };

  const initAll = (root = document) => {
    if (root.matches && root.matches(selector)) initPopup(root);
    root.querySelectorAll?.(selector).forEach(initPopup);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:select', (event) => {
    const popup = event.target.querySelector?.(selector);
    if (popup) {
      initPopup(popup);
      popup._lmdlShow?.();
    }
  });
  document.addEventListener('shopify:section:deselect', (event) => {
    const popup = event.target.querySelector?.(selector);
    popup?._lmdlClose?.({ remember: false });
  });
})();
